import React, {useCallback} from 'react'
import {connect} from "react-redux";
import {setSQFTActiveButton} from "../../../../actions/sqftMenuFunctions";
import {FormattedMessage, injectIntl} from "react-intl";
import {
  setSqftCroppedSlabImages,
  setActiveStep,
  setActiveSlabUrl, setSlabImageHeight, setSlabImageWidth, addSqftCroppedSlabImage,
} from "../../../../actions/sqftSlabFunctions";
import workspace from "../canvas/core/workspace";
import sqftEventManager from "../canvas/store/sqftEventManager";
import {loaderDisable, loaderEnable} from "../../../ui/loaderView";
import SqftLoadSlabFooterSelectImageTypeButtons from "./SqftLoadSlabFooterSelectImageTypeButtons";
import SlabWorkspace from "../canvas/core/slab/slabWorkspace";
import sqftConfig from "../canvas/store/sqftConfig";
import sqftShapeIntersectionsManager from "../canvas/store/sqftShapeIntersectionsManager";
// import {initTitle} from "../canvas/core/controls/labels/labelsHelper";
// import {BACKSPLASH_LABELS} from "../../constants";

const SqftLoadSlabFooter = (props) => {
  const {activeSlabId, setSQFTActiveButton, setActiveSlabUrl, addSqftCroppedSlabImage, pricePerArea} = props;
  const {slabImageWidth, slabImageHeight} = props;
  const {activeStep} = props;
  const {cropperRef} = props;

  const prepareImageDraw = useCallback(() => {
    let imageElement,
      imageSource,
      cropper,
      croppedImage;

    imageElement = cropperRef ? cropperRef.current : null;
    cropper = imageElement ? imageElement.cropper : null;

    if (cropper) {
      const croppedCanvas = cropper.getCroppedCanvas();
      if (croppedCanvas) {
        imageSource = croppedCanvas.toDataURL();

        setActiveSlabUrl(imageSource);

        croppedImage = new Image();
        croppedImage.src = imageSource;

        let workspaceImage = workspace.addImage(
          croppedImage,
          slabImageWidth / sqftConfig.getMeasureMultiplier(),
          slabImageHeight / sqftConfig.getMeasureMultiplier(),
          null,
          null,
          "slabImage",
          null,
          function () {},
          null,
          null,
          null,
          sqftEventManager.priorities.SLAB_IMAGE,
          activeSlabId
        );
        workspaceImage.setPricePerArea(pricePerArea);
        addSqftCroppedSlabImage(workspaceImage);
        // Update shapes intersections and assign feature to placeholder
        sqftShapeIntersectionsManager.updateShapesIntersections();
        workspaceImage.shapeIntersections.handleSlabPlaceholderAndSlabImageIntersections();
      }
      cropper.destroy();
    }

    setTimeout(() => {
      loaderDisable();
    }, 150);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSlabId, addSqftCroppedSlabImage, cropperRef, setActiveSlabUrl, slabImageHeight, slabImageWidth, pricePerArea]);

  const handleCancelClick = () => {
    closePopup();
  };

  const closePopup = () => {
    setSQFTActiveButton("");
  }

  const handleSelectImageClick = () => {
    loaderEnable();
    setSQFTActiveButton("");
    SlabWorkspace.init();
    setTimeout(() => {
      prepareImageDraw();
    }, 0);
  };

  return (
    <div className="message-box-buttons message-box-buttons--modal">
      <div className="message-box-buttons message-box-buttons--modal">
        <button className="ui-button10 ui-button10--blue meta-buttons-confirm-nav--no" onClick={handleCancelClick}>
          <span className="ui-button10-text ui-button10--uppercase">
            <FormattedMessage id={"sqft.popup.buttonCancel"}/>
          </span>
        </button>
        <SqftLoadSlabFooterSelectImageTypeButtons cropperRef={cropperRef}/>
        {
          activeStep === 1 ?
            <button className="ui-button10 ui-button10--green meta-buttons-confirm-nav--yes" onClick={handleSelectImageClick}>
              <span className="ui-button10-text ui-button10--uppercase" data-text="sqft.popup.buttonDelete">
                <FormattedMessage id={"sqft.popup.buttonSelectImage"}/>
              </span>
            </button>
            : null
        }
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  activeSlabId: store.sqftSlabState.activeSlabId,
  activeStep: store.sqftSlabState.activeStep,
  slabImageWidth: store.sqftSlabState.slabImageWidth,
  slabImageHeight: store.sqftSlabState.slabImageHeight,
  pricePerArea: store.sqftSlabState.pricePerArea,
  activeButton: store.sqftMenuState.activeButton,
  slabImageType: store.sqftSlabState.slabImageType,
});

const mapDispatchToProps = {
  setSQFTActiveButton,
  setActiveStep,
  setActiveSlabUrl,
  setSqftCroppedSlabImages,
  setSlabImageHeight,
  setSlabImageWidth,
  addSqftCroppedSlabImage,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftLoadSlabFooter)
)
